import { render, staticRenderFns } from "./AcessarAtaItensBtnHistorico.vue?vue&type=template&id=21a0f3e3"
import script from "./AcessarAtaItensBtnHistorico.vue?vue&type=script&lang=js"
export * from "./AcessarAtaItensBtnHistorico.vue?vue&type=script&lang=js"
import style0 from "./AcessarAtaItensBtnHistorico.vue?vue&type=style&index=0&id=21a0f3e3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports